import { inject, Pipe, PipeTransform } from '@angular/core';
import {
  OutlookTimelineDirection,
  OutlookTimelineEvent,
} from '@maximizer/outlook/shared/domain';
import { TranslateService } from '@ngx-translate/core';

enum EventType {
  Appointment = 'appointment',
  Task = 'task',
  Interaction = 'interaction',
  Email = 'email',
}

@Pipe({
  name: 'timelineEvent',
  pure: false,
})
export class TimelineEventPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(event: OutlookTimelineEvent): string {
    if (!event.interactionType?.display) {
      return '';
    } else if (event.type === EventType.Interaction) {
      return event.interactionType?.display;
    } else {
      return this.translate.instant(
        `outlook.entries.${event.interactionType?.display.toLowerCase()}`,
      );
    }
  }
}

@Pipe({
  name: 'timelineConnection',
  pure: false,
})
export class TimelineConnectionPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(event: OutlookTimelineEvent): string {
    if (
      event.type === EventType.Email ||
      event.type === EventType.Interaction
    ) {
      switch (event.direction) {
        case OutlookTimelineDirection.Incoming:
          return this.translate.instant(
            'outlook.timeline.eventConnection.from',
          );
        case OutlookTimelineDirection.Outgoing:
          return this.translate.instant('outlook.timeline.eventConnection.to');
        default:
          return this.translate.instant(
            'outlook.timeline.eventConnection.with',
          );
      }
    }
    return this.translate.instant('outlook.timeline.eventConnection.with');
  }
}
